module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_honda_04.c52c2c42.jpg";